import axios from 'axios'
import {
  useAddBattleNetToUserMutation,
  useAddEpicToUserMutation,
  useAddPlaystationToUserMutation,
  useAddRiotToUserMutation,
  useAddXboxToUserMutation,
} from 'generated/graphql'

// Mutations
export const useGameAccountMutations = () => {
  const [addPlaystation, { loading: psnLoading }] = useAddPlaystationToUserMutation()
  const [addXbox, { loading: xboxLoading }] = useAddXboxToUserMutation()
  const [addEpic, { loading: epicLoading }] = useAddEpicToUserMutation()
  const [addRiot, { loading: riotLoading }] = useAddRiotToUserMutation()
  const [addBattleNet, { loading: battleNetLoading }] = useAddBattleNetToUserMutation()

  return [
    {
      psn: addPlaystation,
      xbox: addXbox,
      epic: addEpic,
      riot: addRiot,
      battle_net: addBattleNet,
    },
    {
      psn: psnLoading,
      xbox: xboxLoading,
      epic: epicLoading,
      riot: riotLoading,
      battle_net: battleNetLoading,
    },
  ]
}

export const verifyGameAccount = async (gameId, userName): Promise<boolean> => {
  // return true if userName is empty because userName empty means delete connected game account
  if (gameId === 'xbox' || !userName) {
    return true
  }

  try {
    const response = await axios.get(`/api/gameNameVerify?game=${gameId}&name=${encodeURIComponent(userName)}`)
    return response.data?.status === 1
  } catch (err) {
    console.error('[VerifyGameAccount]', err)
    return false
  }
}
